﻿export function bsToggleModal(elementId, isShow) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const instance = bootstrap.Modal.getOrCreateInstance(element);    
    // isShow == null || isShow === undefined ? instance.toggle() : isShow ? instance.show() : instance.hide(); 
    // Chưa test
    if (isShow === null || isShow === undefined) 
        instance.toggle();
    else if (isShow) 
        instance.show();
    else 
        instance.hide();
}
export function bsDisposeModal(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const instance = bootstrap.Modal.getInstance(element);
    if (instance)
        instance.dispose();
}

export function bsInitDropdown(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    new Dropdown(element);
}
export function bsToggleDropdown(elementId, isShow) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const instance = bootstrap.Dropdown.getOrCreateInstance(element);
    if (isShow === null || isShow === undefined)
        instance.toggle();
    else if (isShow)
        instance.show();
    else
        instance.hide();
}
export function bsDisposeDropdown(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const instance = bootstrap.Dropdown.getInstance(element);
    if (instance)
        instance.dispose();
}